import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/uz";
import "dayjs/locale/ru";
import RoutElements from "./router/routes";
import MainContextProvider from "./context";
import { I18nProvider } from "./i18n/context";

// dayjs plugin'larini yuklash
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

// dayjs konfiguratsiyasi
dayjs.locale("uz");

function App() {
  return (
    <I18nProvider>
      <ConfigProvider>
        <Router>
          <MainContextProvider>
            <RoutElements />
          </MainContextProvider>
        </Router>
      </ConfigProvider>
    </I18nProvider>
  );
}

export default App;
